

export default [
	{
		path: '/eres-empleador',
		name:'eresempleador',
		component: () => import('@/views/landing/empleador.vue'),
	},
	{
		path: '/eres-capacitador',
		name: 'erescapacitador',
		component: () => import('@/views/landing/capacitador.vue'),
	},

]




// WEBPACK FOOTER //
// ./src/router/landing.js